const MEMBERSHIP = 'dues';
const EVENT = 'event_fee';
const PAC = 'pac';
const SIC = 'sic';
const FOUNDATION_DONATION = 'foundation_donation_product';
const EVENT_SESSION = 'session_fee';

export default {
    MEMBERSHIP,
    EVENT,
    PAC,
    SIC,
    FOUNDATION_DONATION,
    EVENT_SESSION,
};
